export { default } from './IntakeLink';
